// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"252":"54ed3d29","448":"52ced919","485":"87176547","938":"46138389"}[chunkId] + ".css";
};